import { useState } from 'react';
import useDebouncedMemoizedFunction from './useDebouncedMemoizedFunction';
import type { DebouncedFunc } from 'lodash-es';

export default function useDebouncedImmediateState<T>(
	initialState: T,
	waitMs: number,
): [T, DebouncedFunc<(value: T) => void>, (value: T) => void] {
	const [state, setState] = useState(initialState);

	const debouncedSetter = useDebouncedMemoizedFunction(setState, [setState], waitMs);

	return [state, debouncedSetter, setState];
}
